export default {"src":"/_next/static/media/cdt.c69a82a7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};